import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeOneComponent} from './components/pages/home/home-one.component';
import {ContactComponent} from './components/pages/contact/contact.component';
import {CounselingGuidanceComponent} from './components/pages/counseling-guidance/counseling-guidance.component';
import {PrivacyPolicyComponent} from './components/pages/privacy-policy/privacy-policy.component';
import {BlogComponent} from './components/pages/blog/blog.component';
import {RecommendCandidateComponent} from './components/pages/recommend-candidate/recommend-candidate.component';
import {AboutComponent} from './components/pages/about/about.component';
import {NotFoundComponent} from './components/pages/not-found/not-found.component';
import {TermsAndConditionsComponent} from './components/pages/terms-and-conditions/terms-and-conditions.component';
import {SalaryComparatorComponent} from './components/pages/salary-comparator/salary-comparator.component';
import {ServicesAgriJobsComponent} from './components/pages/services-agri-jobs/services-agri-jobs.component';
import {PackagesComponent} from './components/pages/packages/packages.component';
import {EmployerBrandComponent} from './components/pages/employer-brand/employer-brand.component';
import {MyCareerComponent} from './components/pages/my-career/my-career.component';
import {AgriJobComponent} from './components/pages/agri-job/agri-job.component';
import {AgriStaffComponent} from './components/pages/agri-staff/agri-staff.component';
import {AgriBusinessComponent} from './components/pages/agri-business/agri-business.component';
import {AgencyRecruiterComponent} from './components/pages/agency-recruiter/agency-recruiter.component';
import {FaqComponent} from './components/pages/faq/faq.component';
import {BlogDetailsComponent} from './components/pages/blog-details/blog-details.component';
import {SalaryPackagesComponent} from './components/pages/salary-packages/salary-packages.component';
import {SalaryStudyComponent} from './components/pages/salary-study/salary-study.component';
import { PersonalityAndBehavioralProfileComponent } from './components/pages/personality-and-behavioral-profile/personality-and-behavioral-profile.component';

const jobRoutes: Routes = [
    {path: '', component: HomeOneComponent},
    {path: 'abj-despre', component: AgriStaffComponent},
    {path: 'abj-juniori', component: AgriStaffComponent},
    {path: 'abj-staff', component: AgriStaffComponent},
    {path: 'abj-specialisti', component: AgriStaffComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'blog', component: BlogComponent},
    {path: 'vezi-articol/:id', component: BlogDetailsComponent},
    {path: 'politica-confidentialitate', component: PrivacyPolicyComponent},
    {path: 'termeni-si-conditii', component: TermsAndConditionsComponent},
    {path: 'studiu-salarii', component: SalaryStudyComponent},
    {path: 'comparator-salarii', component: SalaryComparatorComponent},
    {path: 'pachete-salariale', component: SalaryPackagesComponent},
    {path: 'consiliere-si-orientare-cariera', component: CounselingGuidanceComponent},
    {path: 'intrebari-frecvente', component: FaqComponent},
    {path: 'pachete', component: PackagesComponent},
    {path: 'agentie-de-recrutare', component: AgencyRecruiterComponent},
    {path: 'cariera-mea', component: MyCareerComponent},
    {path: 'brand-de-angajator', component: EmployerBrandComponent},
    {path: 'servicii-agri-jobs', component: ServicesAgriJobsComponent},
    {path: 'recomanda', component: RecommendCandidateComponent},
    {path: 'evaluare-personalitate', component: PersonalityAndBehavioralProfileComponent},
    {path: '404', component: NotFoundComponent},

    {path: '', loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule)},
    {path: '', loadChildren: () => import('./modules/jobs/jobs.module').then((m) => m.JobsModule)},

    // {path: '**', redirectTo: '/'} // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(jobRoutes)],
    exports: [RouterModule]
})

export class JobboardRoutingModule {

}
